import React from 'react';

import {SignoffRequestModal} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal';
import {
  CloseURLSidebarPagePanels,
  StyledFooterDIV,
} from 'app/general/structures/DocSidebarPagePanels';
import {useDocumentSignoffs} from 'app/signoffs/api';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import {SignoffDocumentHistory} from './SignoffDocumentHistory';
import {SignoffDocumentStats} from './SignoffDocumentStats';

import type {BaseActionableDocumentType} from 'app/general/types';
import type {DocumentSerializedType} from 'sweet-types';

type Props = {
  document: Exclude<BaseActionableDocumentType, DocumentSerializedType>;
  refreshFunc: () => Promise<unknown>;
};

export const DetailPageSignoffSidebar = ({
  document,
  refreshFunc,
}: Props): JSX.Element => {
  const [isModalVisible, setModalVisible] = React.useState(false);

  const {data: signoffsData, isLoading} = useDocumentSignoffs({
    page: '1',
    page_size: UNLIMITED_PAGE_SIZE,
    object_id: `${document.id}`,
    content_type: document.content_type,
  });

  const allResults = signoffsData?.results ?? [];
  const totalCount = signoffsData?.count ?? 0;

  return (
    <CloseURLSidebarPagePanels
      title={gt('Sign Off Log')}
      closeUrl={document.html_url}
      footer={
        <StyledFooterDIV>
          {document.can_edit && (
            <button
              className="btn btn-secondary btn-sm btn-block"
              onClick={() => setModalVisible(true)}
            >
              <i className="fa fa-signature" /> {gt('Request Sign Off')}
            </button>
          )}
        </StyledFooterDIV>
      }
    >
      {!isLoading && (
        <>
          <SignoffDocumentStats
            document={document}
            signoffsList={allResults}
            loading={isLoading}
          />
          {totalCount > 0 ? (
            <SignoffDocumentHistory document={document} />
          ) : null}
        </>
      )}
      <SignoffRequestModal
        document={document}
        isOpen={isModalVisible}
        contentType={document.content_type}
        onClose={() => setModalVisible(false)}
        onSuccess={refreshFunc}
      />
    </CloseURLSidebarPagePanels>
  );
};
